import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

import { responsive, sp } from '@main/theme';

export const OuterWrapper = styled.div`
  overflow-y: auto;

  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  background-color: ${({ theme }) => theme.colors.sidebarNavBg};

  ${responsive.beforeTablet} {
    padding: 26px;
  }

  ${responsive.atLeastTablet} {
    padding-left: ${sp(4.5)};
    /** So that the bottom-most menu item isn't covered by SideMenuFadeBottom */
    padding-bottom: 68px;
    /** These have to match the offset of SideMenuFadeTop */
    padding-top: 54px;
    margin-top: -54px;
    max-height: 100vh;
  }

  ${responsive.atLeastDesktop} {
    padding-left: ${sp(7)};
  }
`;

/**
 * Gradient fading above the SideMenu in tablet and desktop
 */
export const SideMenuFadeTop = styled.div`
  /** This has to match the offset of OuterWrapper */
  height: 54px;
  background: linear-gradient(
    ${({ theme }) => theme.colors.sidebarNavBg},
    ${({ theme }) => transparentize(1, theme.colors.sidebarNavBg)}
  );
  position: -webkit-sticky;
  position: sticky;
  /** Based off ColWrapper top value, with some extra space */
  /** For top gradient to stick on long content body scroll */
  top: 82px;
  pointer-events: none;
  /** So that the gradient appears above children menu item tabs */
  z-index: 1;

  ${responsive.beforeTablet} {
    display: none;
  }
`;

/**
 * Gradient fading below the SideMenu in tablet and desktop
 */
export const SideMenuFadeBottom = styled.div`
  /** This has to match the offset of the margin-top */
  height: 100px;
  background: linear-gradient(
    ${({ theme }) => transparentize(1, theme.colors.sidebarNavBg)},
    ${({ theme }) => theme.colors.sidebarNavBg}
  );
  /** This offset has to match its height */
  margin-top: -100px;
  position: relative;
  pointer-events: none;

  ${responsive.beforeTablet} {
    display: none;
  }
`;

export const SideMenuWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.sidebarNavBg};
  border-color: ${({ theme }) => theme.colors.sidebarNavBg};
  margin-bottom: ${sp(4)};
`;

export const SideMenuWrapperTitle = styled.h2`
  color: ${({ theme }) => theme.colors.textOnSidebar};
  ${({ theme }) => theme.componentStyles.sideMenuText};
  cursor: pointer;
  font-size: ${sp(2)};
  margin-bottom: ${sp(2)};
  font-weight: 600;
`;

export const SideMenuGroup = styled.div``;

export const SideMenuGroupTitle = styled.div`
  padding: ${sp(1)} ${sp(2)} ${sp(1.5)};
  color: ${({ theme }) => theme.colors.textOnSidebar};
  ${({ theme }) => theme.componentStyles.sideMenuText};
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
`;

export const SideMenuList = styled.ul`
  list-style-type: none;
  outline: none;
  margin: 0;
  padding: 0 0 0 ${sp(5)};
`;

export const sideMenuItemStyles = css`
  opacity: 0.75;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.textOnSidebar};
  font-size: 14px;
  background-color: ${({ theme }) => theme.colors.sidebarNavBg};
  margin-top: -5px;
  margin-left: -12px;
  padding: 0 ${sp(2)} 0 ${sp(3.5)};
  height: 40px;
  line-height: 40px;
  vertical-align: middle;
  transition: opacity 0.15s ease-in-out;

  ::before {
    content: '|';
    opacity: 0;
    color: ${({ theme }) => theme.colors.accentOnSidebar};
    position: relative;
    backface-visibility: hidden;
    transition: opacity 0.15s ease-in-out;
  }

  :hover::before {
    opacity: 1;
  }

  &.active {
    opacity: 1;
    font-weight: 700;

    ::before {
      opacity: 1;
    }
  }
`;
export const SideMenuItem = styled.div`
  ${sideMenuItemStyles};
  padding-left: ${sp(7.5)};

  ::before {
    left: -42px;
  }

  button {
    margin-left: ${sp(-4)};
  }
`;
export const SideMenuListItem = styled.li`
  ${sideMenuItemStyles};
  padding-left: ${sp(5)};

  ::before {
    left: -50px;
  }

  button {
    margin-left: ${sp(-5)};
  }
`;

/**
 * Wrapper for a menu item tab
 */
export const TabWrapper = styled.div`
  display: inline;
  color: ${({ theme }) => theme.colors.textOnSidebar};
  ${({ theme }) => theme.componentStyles.sideMenuText};

  button {
    padding: 0 4px;
    border-radius: ${sp(0.5)};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`;

/**
 * Count wrapper for tabs with data collection previews
 */
export const CountWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.accentOnSidebar};
  color: ${({ theme }) => theme.colors.sidebarNavBg};
  font-family: '${({ theme }) => theme.textStyles.fontFamilyBody.name}';
  font-weight: 700;
  padding: 0 5px;
  font-size: ${sp(1.5)};
  border-radius: 15px;
  width: 32px;
  height: 20px;
  display: inline;
`;
